module.exports = __webpack_public_path__ + "img/u4863_selected.3b8718be.svg";